import { useState, useEffect } from "react";
import { useConnectWallet } from '@web3-onboard/react';

export const useAccount = () => {
  const [{ wallet }] = useConnectWallet();
  const [account, setAccount] = useState(null);

  const handleSetAccount = () =>{
    const address = wallet.accounts[0].address;
    setAccount(address);
  }

  useEffect(() => {
    if(wallet && account === null) handleSetAccount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallet, account]);

  return { account };
}